import { useState, useEffect } from 'react'
import { RegaliaUxConstants } from '../components/regalia-ux'

export const useGetRegaliaUxDialogData = (catalog) => {
    const [data, setData] = useState()

    useEffect(()=>{
        if (catalog && catalog.subCatalogs) {
            // take only unique catalogOsrs for Consumer Type Step 
            const subCatalogsArray = Object.keys(catalog.subCatalogs)?.map(key => ({
                ...catalog.subCatalogs[key]
            }))
            const consumerTypeStep = [... new Set(subCatalogsArray.map(subCatalog => subCatalog.catalogOsr))]
            
            // create required data schema for Catalog Step 
            let catalogStepInitialData = Object.fromEntries(consumerTypeStep.map(element => [element, []]))
            const catalogStep = subCatalogsArray.reduce((acc, subCatalog) => {
                acc[subCatalog.catalogOsr].push({
                    label: subCatalog.catalogName,
                    value: subCatalog.publishedCatalogId
                })
                return acc
            }, catalogStepInitialData)

            const preparedStepData = {
                [RegaliaUxConstants.CONSUMER_TYPE_STEP]: consumerTypeStep,
                [RegaliaUxConstants.CATALOG_STEP]: catalogStep,
            }

            setData({ 
                catalogActionUrl: catalog.actionUrl, 
                stepsData: preparedStepData
            })
        } 

    }, [catalog])

    return data
}